<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.meetings") }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="meetings"
      class="table-row"
      dialogWidth="500"
    >
      <template v-slot="{ item }">
        <td class="text-sm-center">{{ item.host.name }}</td>
        <td class="text-sm-center">{{ getDate(item.start_date_time.date) }}</td>
        <td class="text-sm-center">{{ item.duration }}</td>
        <td class="text-sm-center">{{ item.topic }}</td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="meetings"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-btn icon>
            <v-icon
              @click="showDialog(item)"
              large
              :title="$t('icon.show')"
              small
              >mdi-eye</v-icon
            >
          </v-btn>
        </td>
      </template>
      <!-- dialog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog-header">
          {{ $t("heading.meeting_details") }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="6" class="mx-auto">
                <v-list>
                  <v-list-item-content class="text-center">
                    <v-list-item-avatar size="100">
                      <v-avatar size="100">
                        <v-img
                          :src="meeting.host && meeting.host.main_image.path"
                        ></v-img>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-title
                      class="text-center py-2 font-bold display-1"
                    >
                      {{
                        `${meeting.host.user.firstname} ${
                          meeting.host.user.lastname
                            ? meeting.host.user.lastname
                            : ""
                        }`
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-medium"
                      >{{ meeting.host.job_title }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list>
              </v-col>
              <v-col cols="12" lg="10" class="mx-auto">
                <v-list>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.host_name')">
                        mdi-server</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ meeting.host.name }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.company')">
                        mdi-folder-network</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ meeting.host.company }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.nationality')">
                        mdi-flag</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ meeting.host.nationality }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.qualification')"
                        >mdi-cast-education</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ meeting.host.qualification }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.phone')"
                        >mdi-cellphone</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ meeting.host.Phone.phone }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary" :title="$t('table.birthdate')"
                        >mdi-update</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title class="font-bold">
                      {{ getDate(meeting.host.birthdate) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </template>
      <!-- dialog -->
    </wrapping-table>
  </main>
</template>

<script>
export default {
  name: "Meetings",
  data() {
    return {
      headers: [
        "host_name",
        "started_date",
        "duration",
        "topic",
        "visible",
        "actions",
      ],
      meeting: {
        host: {
          main_image: {
            path: "",
          },
          job_title: "",
          Phone: {
            phone: "",
          },
          user: {
            firstname: "",
            lastname: "",
          },
        },
      },
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    },
    getDate(date) {
      return new Date(date).toDateString();
    },
    showDialog(item) {
      this.meeting = item;
      this.$refs.table_ref.toggleDialog();
    },
  },
};
</script>

